var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDashboPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "137px",
    height: "137px",
    viewBox: "0 0 137 137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_dashbo_purple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_dashbo_purple"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.99,68.495 C136.99,106.323 106.324,136.99 68.495,136.99 C30.666,136.99 0,106.323 0,68.495 C0,30.666 30.666,0 68.495,0 C106.324,0 136.99,30.666 136.99,68.495",
    id: "bg",
    fill: "#440631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2205,80.1014 L68.3675,48.0384 L81.4345,80.0864 L55.2205,80.1014 Z M76.9235,31.9374 L60.0685,31.9374 L33.2065,95.4864 L49.8195,95.4614 L87.0355,95.4614 L87.0505,95.4614 L103.7835,95.4864 L76.9235,31.9374 Z",
    id: "iso",
    fill: "#FF470F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDashboPurple);
export default __webpack_public_path__ + "static/media/logo_dashbo_purple.db55653dafb2dc264870b7a246195c59.svg";
export { ForwardRef as ReactComponent };